import { forwardRef, useCallback } from "react";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import classNames from "classnames";
import { HashLink } from "react-router-hash-link";

import { setPageScrollPosition } from "../../utils/scroll/library";

const LinkWrap = forwardRef(
    (
        {
            url = "",
            external = false,
            className,
            children,
            onClick = () => {},
            hash = "",
            ...rest
        },
        ref
    ) => {
        const { pathname } = useLocation();
        const classes = classNames(className);

        // If the URL is internal, it is safe to strip the domain. React Router
        // says we should just pass the path to the to prop.
        const noDomainUrl = url.replace(/^https?:\/\/\S+\.cbc\.ca/g, "");

        const handleClick = useCallback(
            (e) => {
                setPageScrollPosition(pathname);
                onClick(e);
            },
            [pathname]
        );

        if (hash) {
            return (
                <HashLink
                    to={`${noDomainUrl}${hash}`}
                    ref={ref}
                    onClick={handleClick}
                    className={classes}
                >
                    {children}
                </HashLink>
            );
        }

        return external ? (
            <a
                ref={ref}
                href={url}
                className={classes}
                onClick={onClick}
                {...rest}
            >
                {children}
            </a>
        ) : (
            <Link
                ref={ref}
                onClick={handleClick}
                to={noDomainUrl}
                className={classes}
                {...rest}
            >
                {children}
            </Link>
        );
    }
);

LinkWrap.displayName = "LinkWrap";
LinkWrap._name = "LinkWrap";

LinkWrap.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    external: PropTypes.bool,
    url: PropTypes.string,
    hash: PropTypes.string,
};

export default LinkWrap;
